import KeenSlider from 'keen-slider'

if (document.querySelector('.latest-news .posts-slider')) {
	let navWrapper = document.querySelector(
		'.latest-news .posts .keen-slider-nav'
	)
	let dots = navWrapper.querySelectorAll('.dots .dot')
	let prevArrow = navWrapper.querySelector('.arrows button.prev')
	let nextArrow = navWrapper.querySelector('.arrows button.next')

	var slider = new KeenSlider(
		'.latest-news .posts-slider',
		{
			loop: false,
			slides: {
				perView: 'auto',
				spacing: 16,
			},
			breakpoints: {
				'(min-width: 767px)': {
					slides: {
						perView: 'auto',
						spacing: 24,
					},
				},
			},
		},
		[
			slider => {
				function updateClasses() {
					var slide = slider.track.details.rel
					slide === 0
						? prevArrow.classList.add('arrow--disabled')
						: prevArrow.classList.remove('arrow--disabled')
					slide === slider.track.details.slides.length - 1
						? nextArrow.classList.add('arrow--disabled')
						: nextArrow.classList.remove('arrow--disabled')
					dots.forEach(dot => {
						let idx = parseInt(dot.dataset.index)
						idx === slide ||
						(slider.options.slides.perView >= 2 && idx === slide + 1)
							? dot.classList.add('dot--active')
							: dot.classList.remove('dot--active')
					})
				}

				dots.forEach(dot => {
					dot.addEventListener('click', () => {
						let idx = parseInt(dot.dataset.index)
						idx =
							idx > slider.track.details.maxIdx
								? slider.track.details.maxIdx
								: idx
						slider.moveToIdx(idx)
					})
				})

				prevArrow.addEventListener('click', () => {
					slider.prev()
				})

				nextArrow.addEventListener('click', () => {
					slider.next()
				})

				slider.on('created', () => {
					updateClasses()
				})
				slider.on('slideChanged', () => {
					updateClasses()
				})
				slider.on('optionsChanged', () => {
					updateClasses()
				})
			},
		]
	)

	setTimeout(() => {
		slider.update()
	}, 1000)
}
